import { render, staticRenderFns } from "./examinationTable.vue?vue&type=template&id=e5199b7c"
import script from "./examinationTable.vue?vue&type=script&lang=js"
export * from "./examinationTable.vue?vue&type=script&lang=js"
import style0 from "./examinationTable.vue?vue&type=style&index=0&id=e5199b7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports